import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { ErrorBoundary } from "./lib/ErrorBoundary";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import { AppBootstrap } from "./components/AppBootstrap";

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppBootstrap>
          <RouterProvider router={router} />
        </AppBootstrap>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
